import React from "react";

export default function Footer(){
  return (
    <div className="text-center copy-right">
      &copy; CRM all right reserved - 2020.
    </div>
  );
};